// Lightweight URL + localStorage state persistence for list pages.
// schema: { key: { param: 'queryParamName', parse: (string)=>any, serialize: (val)=>string } }
export function loadState(storageKey, defaults, schema) {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = extractFromParams(params, schema);
  if (Object.keys(fromUrl).length > 0) {
    const merged = { ...defaults, ...fromUrl };
    saveToStorage(storageKey, merged);
    return { state: merged, source: 'url' };
  }
  const stored = readFromStorage(storageKey);
  if (stored) {
    const merged = { ...defaults, ...stored };
    return { state: merged, source: 'storage' };
  }
  return { state: defaults, source: 'default' };
}

export function persistState(storageKey, state, defaults, schema) {
  const params = new URLSearchParams();
  Object.entries(schema).forEach(([key, meta]) => {
    const value = state[key];
    if (value === undefined || value === null) return;
    if (defaults[key] !== undefined && value === defaults[key]) return;
    if (value === '') return;
    params.set(meta.param, meta.serialize ? meta.serialize(value) : String(value));
  });
  const search = params.toString();
  const url = search ? `${window.location.pathname}?${search}` : window.location.pathname;
  window.history.replaceState({}, '', url);
  saveToStorage(storageKey, state);
}

export function resetState(storageKey, defaults) {
  localStorage.removeItem(storageKey);
  window.history.replaceState({}, '', window.location.pathname);
  return defaults;
}

function extractFromParams(params, schema) {
  const out = {};
  Object.entries(schema).forEach(([key, meta]) => {
    if (params.has(meta.param)) {
      const raw = params.get(meta.param);
      out[key] = meta.parse ? meta.parse(raw) : raw;
    }
  });
  return out;
}

function readFromStorage(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

function saveToStorage(storageKey, state) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(state));
  } catch (_) {
    // ignore quota errors
  }
}
